import mutations from 'lg-vue-components/store/modules/layout/mutations';
import getters from 'lg-vue-components/store/modules/layout/getters';
import actions from 'lg-vue-components/store/modules/layout/actions';

const state = () => ({
  nomePortal: '',
  logotipo: '',
  carregandoUsuario: true,
  carregandoLayout: true,
  carregandoLogotipo: true,
  usuario: {
    configuracao: {},
  },
  preview: window.location.href.includes('preview=true'),
  tempoDeSessao: 0,
  produtos: [],
  menus: [],
  menuMapeado: [],
  menusAbertos: [],
  menuAtivo: sessionStorage.getItem('MENU_ATIVO') || '',
  menuUid: sessionStorage.getItem('MENU_UID') || '',
  statusSidebar: false,
  statusSidebarPesquisa: false,
  acoesCustomizadas: {},
});

const layout = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};

export default {
  layout,
};
